import { render, staticRenderFns } from "./CurrentFolder.vue?vue&type=template&id=22402f7a&"
import script from "./CurrentFolder.vue?vue&type=script&lang=js&"
export * from "./CurrentFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports